<template>
  <div class="page" v-loading="false">
    <div class="product-picker">
      <h4>您共可选择{{ pagination.total }}条，已选择{{ this.selectedIds.length }}条</h4>
      <div class="header">
        <div class="search-product">
          <el-input v-model="keyword" placeholder="输入货号/名称/分类搜索" class="keyword" />
          <el-button type="primary" @click.stop="handleSearch">查询</el-button>
          <el-button @click.stop="handleClearSearch">清除</el-button>
        </div>
        <el-checkbox class="select-all" v-model="selectAll" @change="handleSelectedAll"></el-checkbox>
      </div>
      <c-source-table
        :columns="colorProductsColumns()"
        :table="{ data: colorProducts, 'show-header': false, 'row-class-name': tableRowClassName }"
      />
      <el-pagination
        v-model="currentPage"
        background
        class="pagination"
        layout="prev, pager, next, jumper"
        :pager-count="7"
        :page-size="pagination['page-size']"
        :total="pagination['total']"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class ProductsPicker extends Vue {
  @Prop({ type: Array, default: () => [] }) selectedColorProductIdsProp;

  keyword = '';
  table = {};
  colorProducts = [];
  pagination = {};
  currentPage = 1;
  selectedIds = [];
  selectAll = false;

  colorProductsColumns() {
    return [
      {
        prop: 'cover',
        label: '图片',
        renderCell: 'image',
        width: 60
      },
      {
        prop: 'name',
        label: '名称',
        renderCell: (h, { row }) => {
          return (
            <div class="product-desc">
              <div class="product-name">{ row.name }</div>
              <div>
                <span style="margin-right: 10px;">{ row.shop_i_id }</span>
                <span class="published-status">{ row.enabled ? '上架中' : '下架中' }</span>
              </div>
            </div>
          );
        }
      },
      {
        prop: 'categories_names',
        label: '分类',
        width: 250,
        renderCell: (h, { row }) => {
          return (
            <div class="categories-names">{ row.categories_names.join('、') }</div>
          );
        }
      },
      {
        prop: 'selected',
        label: '选择',
        width: 80,
        renderCell: (h, { row }) => {
          const selected = this.selectedIds.indexOf(row.id) !== -1;
          return (
            <el-checkbox value={selected} onChange={(val) => this.handleSelectedChange(val, row)}></el-checkbox>
          )
        }
      }
    ];
  }

  handleSelectedChange(val, row) {
    if (val) {
      this.selectedIds.push(row.id);
    } else {
      this.selectedIds.splice(this.selectedIds.indexOf(row.id), 1);
    }
  }

  handleSelectedAll(val) {
    const allColorProductIds = this.colorProducts.map((ele) => ele.id);
    if (val) {
      this.selectedIds = this.selectedIds.concat(allColorProductIds.filter(id => this.selectedIds.indexOf(id) === -1))
    } else {
      this.selectedIds = this.selectedIds.filter((id) => allColorProductIds.indexOf(id) === -1);
    }
  }

  handleSearch() {
    this.currentPage = 1;
    this.fetchColorProduct();
  }

  handleClearSearch() {
    this.currentPage = 1;
    this.keyword = '';
    this.fetchColorProduct();
  }

  handleCurrentChange(val) {
    this.currentPage = val;
    this.fetchColorProduct();
  }

  async created() {
    await this.fetchColorProduct();
  }

  async fetchColorProduct() {
    const { data, pagination } = await this.$request.get(
      `/color_products?page=${this.currentPage}&per_page=8&filter_by_key_word_in=${this.keyword}`,
      {},
      { loading: false }
    );
    this.colorProducts = data;
    this.pagination = pagination;
    this.selectAll = false;
  }

  submit() {
    return {
      color_product_ids: this.selectedIds
    };
  }

  @Watch('selectedColorProductIdsProp')
  onSelectedColorProductIdsPropChange() {
    this.selectedIds = this.selectedColorProductIdsProp;
  }

  tableRowClassName({ row }) {
    // 已被选中的产品背景颜色暗掉
    if (this.selectedIds.indexOf(row.id) !== -1) {
      return 'disabled-row';
    }
    return '';
  }
}
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  background: white;
  padding: 0;
  margin-top: 30px;

  .product-picker {
    position: relative;
    height: 662px;
    width: 100%;
    padding: 10px;
    border-style: solid;
    border-color: #eae7e7;
    border-width: 1px;

    .header {
      display: flex;
      justify-content: space-between;

      .search-product {
        margin-bottom: 10px;
        .keyword {
          width: 180px;
          margin-right: 10px;
        }
      }
    }

    .pagination {
      background: white;
      position: absolute;
      bottom: 5px;
      right: 0;
    }
  }

  /deep/ .el-checkbox {
    border: 20px solid transparent;
    margin: -10px;
  }

  .select-all {
    margin-right: 13px;
  }

  /deep/ .disabled-row{
    background: #e9e9e9;
  }

  /deep/ .disabled-row:hover>td{
    background: #e9e9e9;
  }

  /deep/ .product-desc {
    text-align: left;

    .product-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .published-status {
      text-align: left;
      color: orange;
    }
  }

  /deep/ .categories-names {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
